import type { SVGProps } from 'react';

const SvgPostingViewing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 32 32'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M28.004 29.332h-24c-.547 0-1-.453-1-1 0-.547.453-1 1-1h24c.547 0 1 .453 1 1 0 .547-.453 1-1 1ZM25.365 4.637c-2.587-2.587-5.12-2.653-7.774 0L15.978 6.25a.555.555 0 0 0-.133.534 10.838 10.838 0 0 0 7.373 7.373.534.534 0 0 0 .547-.133l1.6-1.614c1.32-1.306 1.96-2.573 1.96-3.853.013-1.32-.627-2.6-1.96-3.92Z'
      fill='currentColor'
      opacity={0.4}
    />
    <path
      d='M20.815 15.373c-.387-.187-.76-.373-1.12-.587-.293-.173-.573-.36-.853-.56a8.066 8.066 0 0 1-.747-.573 1.636 1.636 0 0 1-.227-.2c-.44-.373-.933-.853-1.373-1.387-.04-.026-.107-.12-.2-.24-.133-.16-.36-.426-.56-.733a7.32 7.32 0 0 1-.52-.787c-.213-.36-.4-.72-.587-1.093-.186-.4-.333-.787-.466-1.147L5.788 16.44a1.605 1.605 0 0 0-.373.733l-.72 5.107c-.133.906.12 1.76.68 2.333.48.467 1.147.72 1.867.72.16 0 .32-.013.48-.04l5.12-.72c.24-.04.573-.2.733-.373l8.373-8.374c-.373-.133-.733-.28-1.133-.453Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgPostingViewing;
